<template>
  <div class="partneri-popis forma-erp">
    <v-card outlined>
      <v-card-title class="naslov-kartice">
        {{ lang.Partners }}
        <span class="znak">{{ opseg }} · {{ totalItems }} {{ mnozinaPartnera }}</span>
        <v-spacer></v-spacer>
        <span class="znak">{{ lang.PartnerRowOpens }}</span>
      </v-card-title>

      <div class="alatke">
        <!-- Trazi se na potvrdu: kod 18.000 partnera i pretrage po svim poljima
             svaka tipka bi bila jedan upit na bazu. -->
        <div style="max-width:300px">
          <v-text-field
            v-model="searchName"
            :label="langC.Search"
            append-icon="mdi-magnify"
            clearable
            hide-details
            dense
            outlined
            @keyup.enter="doSearch"
            @click:append="doSearch"
            @click:clear="clearSearch"
          ></v-text-field>
        </div>
        <v-btn small color="primary" @click="doSearch">{{ langC.Search }}</v-btn>
        <div style="max-width:200px">
          <v-select
            v-model="vrstaOsobe"
            :items="vrsteOsobe"
            item-text="naziv"
            item-value="vrijednost"
            hide-details
            dense
            outlined
            @change="doSearch"
          ></v-select>
        </div>
        <v-btn small :outlined="!viseStupaca" color="primary" :dark="viseStupaca" @click="viseStupaca = !viseStupaca">
          {{ viseStupaca ? lang.PartnerLessColumns : lang.PartnerMoreColumns }}
        </v-btn>
        <v-progress-circular v-if="saving" indeterminate color="primary" size="22" class="ml-2"></v-progress-circular>
        <v-btn small text color="primary" @click="partnertestvatid">Test OIB-a</v-btn>
        <v-spacer></v-spacer>
      </div>

      <v-data-table
        dense
        :headers="headers"
        :items="partners"
        :options.sync="opcije"
        :server-items-length="totalItems"
        :loading="saving"
        disable-pagination
        hide-default-footer
        item-key="id"
        @click:row="navigateTo"
        :mobile-breakpoint="0"
      >
        <!-- OIB ide ispod naziva, kao sifra kod artikala. -->
        <template v-slot:[`item.partnerName`]="{ item }">
          <div class="naziv" :title="item.partnerName">{{ item.partnerName }}</div>
          <div class="sitno">
            <span v-if="item.partnerVATID">{{ bezZvjezdice(lang.PartnerVATID) }} {{ item.partnerVATID }}</span>
            <span v-if="!item.partnerVATID" class="prazno">{{ lang.PartnerNoVATID }}</span>
            <span v-if="item.privatePerson" class="znak-osoba ml-1">{{ lang.PartnerPrivate }}</span>
          </div>
        </template>

        <!-- Adresa je bila razbijena na cetiri stupca; ovdje je jedan redak. -->
        <template v-slot:[`item.adresa`]="{ item }">
          <div v-if="ulica(item)">{{ ulica(item) }}</div>
          <div class="sitno" v-if="grad(item)">{{ grad(item) }}</div>
          <span v-if="!ulica(item) && !grad(item)" class="prazno">—</span>
        </template>

        <template v-slot:[`item.partneremail`]="{ item }">
          <span v-if="item.partneremail">{{ item.partneremail }}</span>
          <span v-if="!item.partneremail" class="prazno">—</span>
        </template>
        <template v-slot:[`item.partnerPhones`]="{ item }">
          <span v-if="item.partnerPhones">{{ item.partnerPhones }}</span>
          <span v-if="!item.partnerPhones" class="prazno">—</span>
        </template>
        <template v-slot:[`item.partnerBankIBAN`]="{ item }">
          <span v-if="item.partnerBankIBAN" class="sitno">{{ item.partnerBankIBAN }}</span>
          <span v-if="!item.partnerBankIBAN" class="prazno">—</span>
        </template>
        <template v-slot:[`item.partnerType`]="{ item }">
          <span v-if="item.partnerType">{{ item.partnerType }}</span>
          <span v-if="!item.partnerType" class="prazno">—</span>
        </template>
        <template v-slot:[`item.id`]="{ item }">
          <span class="sitno">{{ item.id }}</span>
        </template>

        <template v-slot:no-data>
          {{ lang.noData }}
        </template>
      </v-data-table>

      <div class="podnozje">
        <div class="stavka">
          <span>{{ lang.PartnersTotal }}</span>
          <b>{{ totalItems }}</b>
        </div>
        <div class="stavka">
          <span>{{ lang.PartnersWithIBAN }}</span>
          <b>{{ zbroj.sIbanom }}</b>
        </div>
        <div class="stavka">
          <span>{{ lang.PartnersNoVATID }}</span>
          <b>{{ zbroj.bezOiba }}</b>
        </div>
        <v-spacer></v-spacer>
        <v-pagination
          v-model="page"
          :length="totalPages"
          total-visible="7"
          next-icon="mdi-menu-right"
          prev-icon="mdi-menu-left"
          @input="handlePageChange"
        ></v-pagination>
        <div style="max-width:130px" class="ml-4">
          <v-select
            v-model="pageSize"
            :items="pageSizes"
            :label="lang.PartnersPerPage"
            hide-details
            dense
            outlined
            @change="handlePageSizeChange"
          ></v-select>
        </div>
      </div>
    </v-card>

    <div v-if="dialog">
      <PartnerUpdateVATID :key="componentKey" :id="haveId" />
    </div>
  </div>
</template>

<script>
import PartnerService from '@/services/PartnerService'
import PartnerUpdateVATID from './PartnerUpdateVATID'
import langEn from './PartnerDescEN'
import langHr from './PartnerDescHR'
import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"
import { mapGetters } from 'vuex'

export default {
  name: 'partnerlist',
  data () {
    return {
      lang: {},
      langC: {},
      partners: [],
      searchName: "",
      viseStupaca: false,
      vrstaOsobe: 'svi',
      zbroj: { sIbanom: 0, bezOiba: 0 },
      // Sortiranje se salje na server, da poreda cijeli popis.
      opcije: { sortBy: ['partnerName'], sortDesc: [false] },
      page: 1,
      totalPages: 0,
      pageSize: 30,
      pageSizes: [10, 30, 50],
      totalItems: 0,
      saving: false,
      errorpart: [],
      haveId: null,
      dialog: false,
      componentKey: 0
    }
  },
  mounted () {
      if (this.$store.state.language === "EN") {
        this.lang = langEn
        this.langC = commEn;
      }
      if (this.$store.state.language === "HR") {
        this.lang = langHr
        this.langC = commHr;
      }
      // Stupce slaze izracunato svojstvo "headers".
      this.$store.dispatch('seteditItem', 0)
      if (this.$store.state.searchState) {
        this.searchName = this.$store.state.searchState.searchName ? this.$store.state.searchState.searchName : null
        this.page = this.$store.state.searchState.page ? this.$store.state.searchState.page + 1 : 0
        this.pageSize = this.$store.state.searchState.pageSize ? this.$store.state.searchState.pageSize : 30
        this.$store.dispatch('setSearchState', null)
      }
      this.retrievePartners()
  },
  methods: {
      // Nazivi u sifrarniku nose zvjezdicu za obavezno polje; u popisu smeta.
      bezZvjezdice (naziv) {
        return String(naziv || '').replace(/\s*\*\s*$/, '')
      },
      // Adresa je u bazi razbijena na cetiri polja; u popisu ide kao dva retka.
      ulica (partner) {
        const u = (partner.partnerStreet || '').trim()
        const br = (partner.partnerBuildingNameNumber || '').trim()
        // Kucni broj zna vec biti upisan u ulicu, pa se ne ponavlja.
        if (br && u.split(/\s+/).indexOf(br) === -1) { return (u + ' ' + br).trim() }
        return u
      },
      grad (partner) {
        const g = (partner.partnerCity || '').trim()
        const pb = (partner.partnerPostcode || '').trim()
        if (pb && g.indexOf(pb) === -1) { return (pb + ' ' + g).trim() }
        return g
      },

      async partnertestvatid(){
        const query = {}
        const {data} =  await PartnerService.testvatid(query)

        if (data && data.partners !== undefined && data.partners.length > 0) {
          data.partners.map(part => {
            if (parseInt(part.havesame) > 1 && part.partnerVATID.length > 0) {
              this.errorpart.push(part)
            }
          })
          console.log("🚀 ~ errorpart", this.errorpart)
        }
      },
      setQuery() {
        const query = {}
        query.CompanyId = this.$store.state.companyid
        query.searchName = this.searchName ? this.searchName.trim() : null
        query.page = this.page ? this.page - 1 : 0
        query.pageSize = this.pageSize ? this.pageSize : 30
        query.searchItem = null
        query.osoba = this.vrstaOsobe && this.vrstaOsobe !== 'svi' ? this.vrstaOsobe : null
        query.sortBy = this.opcije.sortBy && this.opcije.sortBy.length ? this.opcije.sortBy[0] : 'partnerName'
        query.sortDesc = this.opcije.sortDesc && this.opcije.sortDesc.length ? this.opcije.sortDesc[0] : false
        return query
      },
      async retrievePartners() {
        
        const query = this.setQuery()
        this.saving = true
        const privateP = this.$store.state.user ? this.$store.state.user.privatePartner : true
        const {data} = privateP ? (await PartnerService.index2(query)) : (await PartnerService.index(query))
        this.saving = false

        this.partners = data && data.partners ? data.partners : []
        this.totalItems = data && data.totalPages ? data.totalPages : 0
        this.totalPages = parseInt(this.totalItems / this.pageSize) + 1
        this.zbroj = data && data.zbroj ? data.zbroj : { sIbanom: 0, bezOiba: 0 }
      },

      handlePageChange(value) {
        this.page = value;
        this.retrievePartners();
      },

      handlePageSizeChange(size) {
        this.pageSize = size;
        this.page = 1;
        this.retrievePartners();
      },

      doSearch() {
        this.page = 1
        this.retrievePartners()
      },
      clearSearch() {
        this.searchName = ''
        this.doSearch()
      },
      navigateTo (params) {
        if (params && params.partnerVATID.length > 0) {
          this.$store.dispatch('setPartnerid', params.id)
          this.$store.dispatch('setPartnerVATID', params.partnerVATID)
          this.$store.dispatch('setSearchState', this.setQuery())
          this.$router.push({
            name: 'partnerview'
          })
        } else {
          this.componentKey += 1
          this.haveId = params.id
          console.log('setiram dialogstate ', this.locDialog)
          this.$store.dispatch('setDialogState', true)
          this.dialog = true
        }
      }

  },
  computed: {
    headers () {
      const stupci = []
      stupci.push({ text: this.bezZvjezdice(this.lang.PartnerName) + ' / ' + this.bezZvjezdice(this.lang.PartnerVATID), value: 'partnerName' })
      stupci.push({ text: this.lang.PartnerAddress, value: 'adresa', sortable: false, width: '230px' })
      stupci.push({ text: this.lang.Partneremail, value: 'partneremail', width: '200px' })
      stupci.push({ text: this.lang.PartnerPhones, value: 'partnerPhones', width: '150px' })
      if (this.viseStupaca) {
        stupci.push({ text: this.lang.PartnerBankIBAN, value: 'partnerBankIBAN', width: '190px' })
        stupci.push({ text: this.lang.PartnerType, value: 'partnerType', width: '80px' })
        stupci.push({ text: 'Db id', align: 'right', value: 'id', width: '80px' })
      }
      return stupci
    },
    // Glavni administrator vidi partnere svih firmi, pa naslov ne smije
    // tvrditi da su to partneri trenutne firme.
    opseg () {
      const u = this.$store.state.user
      return (u && u.Admin === true) ? this.lang.PartnersAllCompanies : this.$store.state.companyName
    },
    vrsteOsobe () {
      return [
        { vrijednost: 'svi', naziv: this.lang.PartnerAllKinds },
        { vrijednost: 'ne', naziv: this.lang.PartnerCompanies },
        { vrijednost: 'da', naziv: this.lang.PartnerPrivatePersons }
      ]
    },
    mnozinaPartnera () {
      const n = this.totalItems
      const zadnja = n % 10
      const zadnje2 = n % 100
      if (zadnja === 1 && zadnje2 !== 11) { return this.lang.PartnerWord1 }
      if (zadnja >= 2 && zadnja <= 4 && (zadnje2 < 12 || zadnje2 > 14)) { return this.lang.PartnerWord2 }
      return this.lang.PartnerWord5
    },

    ...mapGetters({
      locDialog: 'NeedDialogState'
    })
  },
  watch: {
    // Klik na zaglavlje mijenja poredak - novi upit, jer se sortira cijeli popis.
    opcije: {
      deep: true,
      handler (novo, staro) {
        if (!staro) { return }
        const istoPolje = JSON.stringify(novo.sortBy) === JSON.stringify(staro.sortBy)
        const istiSmjer = JSON.stringify(novo.sortDesc) === JSON.stringify(staro.sortDesc)
        if (istoPolje && istiSmjer) { return }
        this.page = 1
        this.retrievePartners()
      }
    },
    'locDialog' () {
      console.log(' imam novi state', this.locDialog)
      this.dialog = this.locDialog
      this.retrievePartners()
      //this.locDialog = this.$store.state.dialogState
    },
  },
  components: {
    PartnerUpdateVATID
  }
}
</script>

<style scoped>
.partneri-popis .naslov-kartice {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #1565c0;
  background: #eef4fb;
  border-bottom: 2px solid #1976d2;
  padding: 8px 16px;
  min-height: 0;
  gap: 10px;
}
.partneri-popis .naslov-kartice .znak {
  font-size: 13px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
}
.partneri-popis .alatke {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 10px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.partneri-popis .naziv {
  font-weight: 500;
  line-height: 1.25;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.partneri-popis .sitno {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.2;
}
.partneri-popis .prazno {
  color: #cfd8dc;
}
.partneri-popis .znak-osoba {
  display: inline-block;
  font-size: 11px;
  background: #e3f2fd;
  color: #1565c0;
  border: 1px solid #90caf9;
  border-radius: 9px;
  padding: 0 7px;
}
.partneri-popis >>> tbody tr {
  cursor: pointer;
}
.partneri-popis >>> td {
  white-space: nowrap;
}
.partneri-popis >>> td:nth-child(1),
.partneri-popis >>> td:nth-child(2) {
  white-space: normal;
}
.partneri-popis .podnozje {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;
  padding: 10px 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  background: #fafafa;
}
.partneri-popis .podnozje .stavka span {
  display: block;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.1;
}
.partneri-popis .podnozje .stavka b {
  font-size: 16px;
  font-variant-numeric: tabular-nums;
}
</style>
